import React from 'react';
import styles from './TerminalFrame.module.scss';
import { isPortraitOrientation } from '../Utils/isPortraitOrientation';
interface TerminalFrameProps {
  children: React.ReactNode;
  aspectRatio?: string;
}

/**
 * Gets the appropriate CSS class names based on orientation
 * @param aspectRatio - String in format "width/height"
 * @returns object containing CSS class names for container, frame, and content
 */
const getOrientationClasses = (aspectRatio: string) => {
  const isPortrait = isPortraitOrientation(aspectRatio);
  
  return {
    container: isPortrait ? styles.terminalFrameContainerPortrait : styles.terminalFrameContainer,
    frame: isPortrait ? styles.terminalFramePortrait : styles.terminalFrame,
    content: isPortrait ? styles.contentContainerPortrait : styles.contentContainer
  };
};

export const TerminalFrame = ({ children, aspectRatio = '16/10' }: TerminalFrameProps) => {
  const classes = getOrientationClasses(aspectRatio);
  
  return (
    <div 
      className={classes.container}
    >
      <div className={classes.frame}>
        <div className={classes.content}>
          {children}
        </div>
      </div>
    </div>
  );
} 